import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import { toastError } from '@components/Toast';

import { fetchProductInfo } from '@store/actions/DesignToolAction';
import { getBrands as fetchAllBrands } from '@store/design/action';
import { getAllBrands, getAllTags } from '@store/reducers';
import { fetchAllTags } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import { checkUserType } from '@utils/Util';

const UpdateFittingModal = ({
	productId,
	onAddSuccess,
	isShowClose,
	onCloseModal,
	blockResponse,
	blockSaveType,
	updateProductCardOnMark,
	openedFrom,
	isBottomCategory
}) => {
	const [searchTerm] = useState('');
	const [selectedListType, setSelectedListType] = useState('PRODUCT_FITTING_TYPE');
	const [selectedBlockResponse, setSelectedBlockResponse] = useState(blockResponse);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState(false);
	const [isShowAddNew, setIsShowAddNew] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setSelectedBlockResponse(blockResponse);
	}, [blockResponse]);

	useEffect(() => {
		if (checkUserType('ADMIN')) {
			setIsShowAddNew(true);
		}
	}, []);

	let allTags = useSelector(getAllTags)?.allTags?.map((item) => {
		return {
			id: item.id,
			value: item.text
		};
	});

	let allBrands = useSelector(getAllBrands)?.map((item) => {
		return {
			id: item.id,
			value: item.name,
			docUrl: item.brandLogoDocResponse.docUrl
		};
	});

	const onAddListType = (value, type) => {
		let selectedItem = { text: value.value };
		if (value?.id) {
			selectedItem['id'] = value.id;
		}
		if (type === 'PRODUCT_FITTING_TYPE') {
			setSelectedBlockResponse({ ...selectedBlockResponse, fittingTypeTag: selectedItem });
		} else if (type === 'PRODUCT_SIZE_STANDARD')
			setSelectedBlockResponse({ ...selectedBlockResponse, sizeStandardTag: selectedItem });
		else if (type === 'PRODUCT_LENGTH')
			setSelectedBlockResponse({ ...selectedBlockResponse, lengthTag: selectedItem });
		else if (type === 'PRODUCT_AVATAR')
			setSelectedBlockResponse({ ...selectedBlockResponse, avatarTag: selectedItem });
		else setSelectedBlockResponse({ ...selectedBlockResponse, riseTag: selectedItem });
	};

	const handleCheckboxChange = () => {
		setSelectedBlockResponse((prevState) => {
			const newState = prevState || {};
			return {
				...newState,
				isApprovedByBrand: !newState.isApprovedByBrand
			};
		});
	};
	useEffect(() => {
		dispatch(fetchAllTags(searchTerm, selectedListType));
	}, [selectedListType, searchTerm]);

	useEffect(() => {
		dispatch(fetchAllBrands());
	}, []);

	const validateForm = () => {
		let cloneError = {};
		if (!selectedBlockResponse?.inspirationBrand) {
			cloneError.brand = 'Field is required';
		}
		if (!selectedBlockResponse?.fittingTypeTag) {
			cloneError.fittingTypeTag = 'Field is required';
		}
		if (isBottomCategory && !selectedBlockResponse?.riseTag) {
			cloneError.rise = 'Field is required';
		}
		if (isBottomCategory && !selectedBlockResponse?.lengthTag) {
			cloneError.length = 'Field is required';
		}
		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};

	const onSubmitSize = async (saveAsBlock) => {
		if (!validateForm()) {
			let body = {
				id: productId,
				productId: productId,
				fittingTypeTagRequest: selectedBlockResponse?.fittingTypeTag,
				riseTagRequest: selectedBlockResponse?.riseTag,
				lengthTagRequest: selectedBlockResponse?.lengthTag,
				sizeStandardTagRequest: selectedBlockResponse?.sizeStandardTag,
				avatarTagRequest: selectedBlockResponse?.avatarTag,
				inspirationBrandId: selectedBlockResponse?.inspirationBrand?.id,
				blockTitle: selectedBlockResponse?.blockTitle,
				blockRemarks: selectedBlockResponse?.blockRemarks,
				isBlock: saveAsBlock ? true : false,
				isApprovedByBrand: selectedBlockResponse?.isApprovedByBrand
			};
			setIsSubmitting(true);
			await ApiClient.PUT('upDateProductBlock', body, productId)
				.then((data) => {
					dispatch(fetchProductInfo(productId));
					if (openedFrom !== 'measurement') {
						updateProductCardOnMark(data.data);
					}
					setError(false);
					setIsSubmitting(false);
					if (onAddSuccess) {
						onAddSuccess();
					}
				})
				.catch(({ response }) => {
					setIsSubmitting(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		}
	};

	return (
		<ModalContainer onCloseModal={() => {}}>
			<div className="common-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">
							{blockSaveType === 'add' ? 'Block' : 'Edit block'}

							{/* <span className="gray_dark_02">{selectedBlockResponse?.productRefNo}</span> */}
						</h3>
					</div>
					{isShowClose && (
						<div className="close-btn" onClick={onCloseModal}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</div>
					)}
				</div>
				<div className="common-popup-body">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="fitting-type">Block Name</label>
									<input
										type="text"
										id="block-name"
										onChange={(e) =>
											setSelectedBlockResponse({
												...selectedBlockResponse,
												blockTitle: e.target.value
											})
										}
										value={selectedBlockResponse?.blockTitle}
									/>
								</div>
							</div>
							<div className="col-md-6 pr-6">
								<div className="form-group ">
									<label htmlFor="rise">Brand*</label>
									<CustomDropdown
										isShowLabel={false}
										onItemClick={(value) => {
											setSelectedBlockResponse({
												...selectedBlockResponse,
												inspirationBrand: { name: value?.value, id: value.id }
											});
										}}
										items={allBrands}
										selectedItem={selectedBlockResponse?.inspirationBrand?.name}
									/>
									{error.brand && <p className="error">{error.brand}</p>}
								</div>
							</div>
							<div className="col-md-6 pl-6">
								<div
									className="form-group "
									onClick={() => setSelectedListType('PRODUCT_SIZE_STANDARD')}
								>
									<label htmlFor="rise">Region/Size standard</label>
									<CustomDropdown
										isShowLabel={false}
										items={allTags}
										selectedItem={selectedBlockResponse?.sizeStandardTag?.text}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_SIZE_STANDARD')}
									/>
								</div>
							</div>
							<div className="col-md-6 pr-6">
								<div
									className="form-group"
									onClick={() => setSelectedListType('PRODUCT_AVATAR')}
								>
									<label htmlFor="rise">Avatar</label>
									<CustomDropdown
										isShowLabel={false}
										items={allTags}
										isAddNewOnInline={isShowAddNew}
										selectedItem={selectedBlockResponse?.avatarTag?.text}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_AVATAR')}
									/>
								</div>
							</div>
							<div className="col-md-6 pl-6">
								<div
									className="form-group"
									onClick={() => setSelectedListType('PRODUCT_FITTING_TYPE')}
								>
									<label htmlFor="fitting-type">Fitting type*</label>
									<CustomDropdown
										isShowLabel={false}
										toolTipLength={18}
										items={allTags}
										selectedItem={selectedBlockResponse?.fittingTypeTag?.text}
										isAddNewOnInline={isShowAddNew}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_FITTING_TYPE')}
									/>{' '}
									{error.fittingTypeTag && <p className="error">{error.fittingTypeTag}</p>}
								</div>
							</div>
							<div className="col-md-6 pr-6">
								<div
									className="form-group "
									onClick={() => setSelectedListType('PRODUCT_RISE')}
								>
									<label htmlFor="rise">Rise{isBottomCategory && '*'}</label>
									<CustomDropdown
										isShowLabel={false}
										items={allTags}
										selectedItem={selectedBlockResponse?.riseTag?.text}
										isAddNewOnInline={isShowAddNew}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_RISE')}
									/>
									{error.rise && <p className="error">{error.rise}</p>}
								</div>
							</div>
							<div className="col-md-6 pl-6">
								<div
									className="form-group "
									onClick={() => setSelectedListType('PRODUCT_LENGTH')}
								>
									<label htmlFor="rise">Length{isBottomCategory && '*'}</label>
									<CustomDropdown
										isShowLabel={false}
										items={allTags}
										selectedItem={selectedBlockResponse?.lengthTag?.text}
										isAddNewOnInline={isShowAddNew}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_LENGTH')}
									/>
									{error.length && <p className="error">{error.length}</p>}
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group mb-0">
									<label htmlFor="remarks">Remarks</label>
									<textarea
										name="remarks"
										id="remarks"
										placeholder="Write Remarks"
										onChange={(e) =>
											setSelectedBlockResponse({
												...selectedBlockResponse,
												blockRemarks: e.target.value
											})
										}
										value={selectedBlockResponse?.blockRemarks}
									/>
								</div>
							</div>
							<div className="col-md-12 pt-2">
								<div className="custom-chekbox">
									<div className="form-group m-0">
										<input
											type="checkbox"
											id="isApprovedByBrand"
											name="isApprovedByBrand"
											checked={selectedBlockResponse?.isApprovedByBrand || false}
											onChange={handleCheckboxChange}
										/>

										<label htmlFor="isApprovedByBrand" className="m-0">
											<span className="align-middle">Approved by Brand</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCloseModal}>
							Cancel
						</button>
						<button
							className="button outline size32 ml-2"
							disabled={isSubmitting}
							onClick={() => onSubmitSize(false)}
						>
							Only update block info
						</button>
						{blockSaveType !== 'edit' && !selectedBlockResponse?.isBlock && (
							<button
								className="button size32 ml-2"
								disabled={isSubmitting}
								onClick={() => onSubmitSize(true)}
							>
								Mark as a block
							</button>
						)}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default UpdateFittingModal;
